<template>
  <div class="hexagram-diagram">
    <!-- 本卦 -->
    <div class="hexagram">
      <div class="hexagram-title">本卦</div>
      <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`">
        
        <!-- 绘制爻线 -->
        <g v-for="(yao, index) in yaos" :key="index" 
           :transform="`translate(0, ${getYaoY(index)})`">
          <!-- 阳爻 -->
          <template v-if="isYangYao(yao)">
            <line x1="0" :y1="lineY" :x2="lineWidth" :y2="lineY" 
                  :class="['yao-line', { 'changing': isChangingYao(yao) }]" />
          </template>
          <!-- 阴爻 -->
          <template v-else>
            <line x1="0" :y1="lineY" :x2="lineWidth * 0.4" :y2="lineY" 
                  :class="['yao-line', { 'changing': isChangingYao(yao) }]" />
            <line :x1="lineWidth * 0.6" :y1="lineY" :x2="lineWidth" :y2="lineY" 
                  :class="['yao-line', { 'changing': isChangingYao(yao) }]" />
          </template>
          <!-- 变爻标记 -->
          <circle v-if="isChangingYao(yao)" 
                  :cx="lineWidth + 10" 
                  :cy="lineY" 
                  r="3" 
                  class="changing-mark" />
        </g>
      </svg>
      <div class="hexagram-title">{{ hexagram?.name || '' }}卦</div>
    </div>

    <!-- 箭头 -->
    <div v-if="changedHexagram" class="arrow">→</div>

    <!-- 变卦 -->
    <div v-if="changedHexagram" class="hexagram">
      <div class="hexagram-title">变卦</div>
      <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`">
        <g v-for="(yao, index) in yaos" :key="index" 
           :transform="`translate(0, ${getYaoY(index)})`">
          <!-- 变卦的爻线 -->
          <template v-if="shouldBeYang(yao, index)">
            <line x1="0" :y1="lineY" :x2="lineWidth" :y2="lineY" class="yao-line" />
          </template>
          <template v-else>
            <line x1="0" :y1="lineY" :x2="lineWidth * 0.4" :y2="lineY" class="yao-line" />
            <line :x1="lineWidth * 0.6" :y1="lineY" :x2="lineWidth" :y2="lineY" class="yao-line" />
          </template>
        </g>
      </svg>
      <div class="hexagram-title">{{ changedHexagram?.name || '' }}卦</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { YAO_TYPES, isChangingYao } from '@/constants/iching'

const props = defineProps({
  yaos: {
    type: Array,
    required: true
  },
  changedYaos: {
    type: Array,
    default: () => []
  },
  hexagram: {
    type: Object,
    required: true
  },
  changedHexagram: {
    type: Object,
    default: null
  }
})

// SVG 尺寸和样式配置
const width = 60
const height = 120
const lineWidth = 50
const lineY = 2
const yaoGap = 16

// 计算爻的 Y 坐标
const getYaoY = (index) => height - (index + 1) * yaoGap

// 判断是否为阳爻
const isYangYao = (yao) => yao === YAO_TYPES.YOUNG_YANG || yao === YAO_TYPES.OLD_YANG

// 判断变卦中的爻是否应该为阳
const shouldBeYang = (yao, index) => {
  const isChanging = props.changedYaos.some(changed => changed.position === index)
  if (!isChanging) return isYangYao(yao)
  return yao === YAO_TYPES.OLD_YIN || yao === YAO_TYPES.YOUNG_YANG
}
</script>

<style scoped>
.hexagram-diagram {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.hexagram {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hexagram-title {
  margin-bottom: 0.5rem;
  color: var(--color-accent);
}

.yao-line {
  stroke: var(--color-accent);
  stroke-width: 2;
}

.yao-line.changing {
  animation: pulse 2s infinite;
}

.changing-mark {
  fill: var(--color-accent);
}

.arrow {
  color: var(--color-accent);
  font-size: 1.5rem;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style> 